import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import StaffId               from "../../../domain/staff/StaffId";
import StaffRepository       from "../../../domain/staff/StaffRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import StaffDataSource       from "../../../infrastructure/datasource/staff/StaffDataSource";
import RouterDispatcher      from "../../../infrastructure/redux/router/RouterDispatcher";
import GetStaffs             from "./GetStaffs";

class DeleteStaff {
  constructor(
    private readonly dispatch,
    private readonly staffRepository: StaffRepository = new StaffDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly getStaffs: GetStaffs = new GetStaffs(dispatch),
    private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(dispatch),
  ) {
  }

  public async execute(staffId: StaffId) {
    this.fetchStatusRepository.start();
    try {
      await this.staffRepository.delete(staffId);
      await this.getStaffs.execute();
      this.routerDispatcher.staffs();
      this.notifyRepository.deleteSuccess()
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteStaff;
